import { TIME_AVAILABLE } from '../actions/timeSlots';


const initialState = {timeAvailable: false}

 const timeSlotsReducer = (state = initialState, action) => {
  switch (action.type) {

  case TIME_AVAILABLE:
    return {
        ...state,
        timeAvailable: true,
    
    }
     
  default:
    return state
  }
}
export default timeSlotsReducer;



// WEBPACK FOOTER //
// ./src/reducers/timeSlots.js